// extracted by mini-css-extract-plugin
export default {"UsePavelifyLink":"UsePavelifyLink_UsePavelifyLink__KWpY+"};